import {IHostingSettingsState} from "../reducers/hosting-settings.reducer";
import {createFeatureSelector, createSelector} from "@ngrx/store";
import {DbStoreState} from "../reducers";

const getDbStoreState = createFeatureSelector<DbStoreState>('dbStore');

export const getHostingSettingsState = createSelector(getDbStoreState, (dbStoreState: DbStoreState) => dbStoreState.hostingSettings);

export const getHostingSettings = (websiteId: number) => createSelector(getHostingSettingsState,
  (state: IHostingSettingsState) =>
    (state.entities[websiteId] && state.entities[websiteId].entities) ? state.entities[websiteId].entities : null
);


export const getHostingSettingsMap = (websiteId: number) => createSelector(getHostingSettingsState,
  (state: IHostingSettingsState) =>
    state.entities[websiteId]
);


export const getHostingSettingsLoading = (websiteId: number) => createSelector(getHostingSettingsState,
  (state: IHostingSettingsState) =>
    state.entities[websiteId].loading
);

export const getHostingSettingsLoaded = (websiteId: number) => createSelector(getHostingSettingsState,
  (state: IHostingSettingsState) =>
    state.entities[websiteId] ? state.entities[websiteId].loaded : false
);
